export default "__VITE_ASSET__e43ac97d__"